import { useEffect, useState } from "react";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { TagGroupService } from "../../services/TagGroupService";
import { useTranslation } from "react-i18next";

export default function AddGroupModal({ 
  isOpen, 
  closeModal, 
  groupEdit, 
  onClose,
  onSubmmitSuccess,
  modalTitleProp,
  buttonTitleProp
 }) {
  const { t } = useTranslation();
  const [group, setGroup] = useState({});
  const [error, setError] = useState({});
  const [modalTitle, setModalTitle] = useState(modalTitleProp || t("New Group"));
  const [buttonTitle, setButtonTitle] = useState(buttonTitleProp || t("Create"));

  useEffect(() => {
    if (modalTitleProp) {
      setModalTitle(modalTitleProp);
    }
  }, [modalTitleProp]);

    useEffect(() => {
    if (buttonTitleProp) {
      setButtonTitle(buttonTitleProp);
    }
  }, [buttonTitleProp]);

  useEffect(() => {
    if (groupEdit && groupEdit.id) {
      setModalTitle(t("Edit Group"));
    } else {
      setModalTitle(t("New Group"));
    }
  }, [groupEdit, isOpen]);

    useEffect(() => {
    if (groupEdit && groupEdit.id) {
      setButtonTitle(t("Edit"));
    } else {
      setButtonTitle(t("Create"));
    }
  }, [groupEdit, isOpen]);

  const submmit = () => {
    if (valid())
      if (!groupEdit.id) {
        createGroup();
      } else {
        updateGroup();
      }
  };

  function createGroup() {
    TagGroupService.createTagGroup(group).then(() => {
      setGroup({});
      closeModal();
      if (onSubmmitSuccess) {
        onSubmmitSuccess();
      }
    });
  }
  function updateGroup() {
    TagGroupService.updateTagGroup(group).then(() => {
      setGroup({});
      closeModal();
      if (onSubmmitSuccess) {
        onSubmmitSuccess();
      }
    });
  }

  function valid() {
    const error = {};
    if (!group.name) error.name = t("Name is required");
    setError(error);
    return Object.keys(error).length === 0;
  }

  useEffect(() => {
    setGroup(groupEdit);
  }, [groupEdit.id]);
  
  function onChange({ target }) {
    setGroup({ ...group, [target.name]: target.value });
  }

    function handleClose() {
    closeModal();
    if (onClose) {
      onClose();
    }
  }

  return (
    <ModalContainer
      isOpen={isOpen}
      modalTitle={modalTitle}
      closeModal={handleClose}
      crossmarkAction={handleClose}
      cancelButtonAction={handleClose}
      cancelButtonTitle="Cancel"
      submitButtonTitle={buttonTitle}
      modalSize="sm"
      submitButtonAction={submmit}
    >
      <div className="form-group">
        <div className="label-wrraper">
          <label>{t("Name")}</label>
          {error.name && <span className="error-msg">{error.name}</span>}
        </div>

        <input
          type="text"
          name="name"
          value={group.name}
          onChange={onChange}
          className="form-control"
        />
      </div>
      <div className="form-group">
        <label>{t("Description")}</label>
        <input
          type="text"
          name="description"
          value={group.description}
          onChange={onChange}
          className="form-control"
        />
      </div>
    </ModalContainer>
  );
}
